/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, OnDestroy } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import {
    HOVER_OVERLAY_TOP_POSITION,
} from 'ng/modules/tooltip/components/avi-hover-overlay/avi-hover-overlay.constants';

import {
    defaultShowNonSignificantLogs,
    defaultShowSignificantLogs,
    defaultShowUserDefinedLogs,
} from '../../../constants/default-values.constants';

import * as l10n from './traffic-logs-significance-options.l10n';
import './traffic-logs-significance-options.component.less';
import { ITrafficLogsStates, TrafficLogsStore } from '../traffic-logs.store';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Significant and Non-Significant checkboxes for traffic logs.
 * @author Yogesh Patil
 */
@Component({
    selector: 'traffic-logs-significance-options',
    templateUrl: './traffic-logs-significance-options.component.html',
})
export class TrafficLogsSignificanceOptionsComponent implements OnDestroy {
    public readonly globalL10nKeys = globalL10nKeys;
    public readonly l10nKeys = l10nKeys;

    /**
     * Flag for if significant logs checkbox is selected. Maps to adf API param.
     */
    public showSignificantLogs: boolean = defaultShowSignificantLogs;

    /**
     * Flag for if non-significant logs checkbox is selected. Maps to nf API params.
     */
    public showNonSignificantLogs: boolean = defaultShowNonSignificantLogs;

    /**
     * Flag for if user defined logs checkbox is selected. Maps to udf API param.
     */
    public showUserDefinedLogs: boolean = defaultShowUserDefinedLogs;

    /**
     * Non significant logs helper message position.
     */
    public readonly hoverOverlayPositionPriorities: ConnectedPosition[] = [
        HOVER_OVERLAY_TOP_POSITION,
    ];

    /**
     * Uncheck the non-significant checkbox if non-significant logs get deactivated.
     * Save subscription to destroy later.
     */
    private readonly nonSignificantLogsEnabledSubscription =
        this.trafficLogsStore.nonSignificantLogsEnabled$.subscribe(
            () => this.showNonSignificantLogs = false,
        );

    constructor(
        l10nService: L10nService,
        protected readonly trafficLogsStore: TrafficLogsStore<ITrafficLogsStates>,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnDestroy(): void {
        this.nonSignificantLogsEnabledSubscription.unsubscribe();
    }
}
